import { Select } from "antd";
const { Option } = Select;

export const ValueSelectInput = ({
    name,
    options = [],
    value = [],
    onChangeValueSelect,
    placeholder = "Select value",
}) => {
    return (
        <Select
            id={`select-${name}`}
            mode="multiple"
            defaultValue="Austin"
            style={{ width: "100%" }}
            rootClassName="custom-select"
            value={value}
            onChange={onChangeValueSelect}
            filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
            }
            maxTagCount={0}
            allowClear
            placeholder={placeholder}
        >
            {options.map((option, i) => (
                <Option key={i} value={option.value}>
                    {option.value}
                </Option>
            ))}
        </Select>
    );
};
